import { useHeavent } from 'common-front/src/hooks/useHeavent';
import { MappableImportWizard } from 'common-front/src/import/mappableImportWizard';
import { CustomFieldVariety, OrganizationId } from 'common/src/generated/types';
import { DelegationsImportInputService } from 'common/src/input/delegationsImportInput';
import { DelegationsPaths } from 'common/src/util/paths/delegationsPaths';
import { UUID } from 'common/src/util/uuid';
import * as React from 'react';
import {
    useDelegationsImportMutation,
    useOrganizationImportInfosQuery
} from '../../generated/graphqlHooks';
import { useNotificationContext } from '../../notifications/notificationContext';

export const DelegationsImport = () => {
    const {
        params: { organizationId, eventId },
        translate
    } = useHeavent();
    const { mutate } = useDelegationsImportMutation();
    const { checkDelegationsImport: _checkDelegationsImport } = useNotificationContext();
    // TODO - if all import notification checks will eventually require `eventId` args, we can make that the new baseline
    // and remove this special case handler.
    const checkDelegationsImport = React.useCallback(
        (organizationId: OrganizationId, jobId: UUID) =>
            _checkDelegationsImport(organizationId, eventId, jobId),
        [_checkDelegationsImport, eventId]
    );
    const { data, loader } = useOrganizationImportInfosQuery({
        organizationId,
        variety: CustomFieldVariety.Delegation
    });

    return (
        loader || (
            <MappableImportWizard
                ImportInputService={DelegationsImportInputService}
                checkImport={checkDelegationsImport}
                closePath={DelegationsPaths.DELEGATIONS({ organizationId, eventId })}
                customFields={data.organization.customFields.nodes}
                importTagPrefix="delegations"
                itemName={{ singular: translate('team_33516'), plural: translate('teams_75559') }}
                localStorageKeyPrefix="DELEGATIONS_IMPORT"
                mutate={mutate}
                showModeSelection={false}
                title={translate('import_de_d_l_g_69356')}
            />
        )
    );
};
